import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const InfoBox = ({ title, content, darkMode }) => {
  if (!content || content === "NaN") {
    return null; // Render nothing if content is invalid
  }

  return (
    <MDBox
      mb={3}
      display="block"
      bgColor={darkMode ? "transparent" : "white"}
      color="text"
      borderRadius="xl"
      mt={2.5}
      py={1.875}
      px={1.875}
      lineHeight={1.5}
      sx={{
        border: ({ borders: { borderWidth }, palette: { white } }) =>
          darkMode ? `${borderWidth[1]} solid ${white.main}` : 0,
        fontSize: ({ typography: { size } }) => size.md,
      }}
    >
      <MDTypography variant="h6" fontWeight="medium" mt={1}>
        {title}
      </MDTypography>
      {content}
    </MDBox>
  );
};

export default InfoBox;
